var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("common-page", {
    ref: "commonPage",
    attrs: {
      "bg-path": _vm.bgPath,
      "web-path": _vm.webPath,
      columns: _vm.columns,
      "table-options": _vm.tableOptions,
      "search-items": _vm.searchItems,
      "form-items": _vm.formItems,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }